import React, { useState, useContext, useEffect } from 'react';
import { navigate } from 'hookrouter';

import { DataContext } from '../stores/crm-organization-store';
import VirtualScroller from '../components/crm/shared/VirtualScroller';
import { Header } from '../components/crm/shared/TableCells';

import ErrorPage from './error';

const CrmOrganizations = () => {
    const [error] = useState(null);

    const {
        store: { layout, viewSettings },
        dispatch,
    } = useContext(DataContext);

    const handleOnClick = (item) => {
        dispatch({
            type: 'UPDATE_ACTIVE_ORGANIZATION',
            payload: item,
        });
        navigate('/crmOrganizationDetails/' + item.id);
    };

    const content =
        error && error ? (
            <ErrorPage error={error} />
        ) : (
            <section className='w-100 crm-container'>
                <div className='d-flex'>
                    <div className='position-relative justify-content-left align-items-left'>
                        <div className='d-flex flex-column w-100'>
                            <Header layout={layout} dataContext={DataContext} />
                            {viewSettings !== null ? <VirtualScroller dataContext={DataContext} onCellClick={handleOnClick} /> : null}
                        </div>
                    </div>
                </div>
            </section>
        );
    return content;
};

export default CrmOrganizations;
